var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Center, Table as OriginTable, Tbody, Td, Th, Thead, Tr, } from '@chakra-ui/react';
import { useRowSelect, useTable, } from 'react-table';
import { Pagination } from '../Pagination';
import { IndeterminateCheckbox } from './IndeterminateCheckbox';
import { Radio } from './Radio';
export const Table = (_a) => {
    var { data, columns, isLoading, pagination = false, tdLayout = 'loose', rowSelection, onRow } = _a, extraTableProps = __rest(_a, ["data", "columns", "isLoading", "pagination", "tdLayout", "rowSelection", "onRow"]);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
        columns,
        data,
        initialState: {
            selectedRowIds: ((rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.defaultSelectedRowIds) || []).reduce((prev, cur) => (Object.assign(Object.assign({}, prev), { [cur]: true })), {}),
        },
        manualRowSelectedKey: rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.manualRowSelectedKey,
    }, ...(rowSelection
        ? [
            useRowSelect,
            (hooks) => {
                hooks.visibleColumns.push((columns) => [
                    // Let's make a column for selection
                    {
                        id: 'selection',
                        // The header can use the table's getToggleAllRowsSelectedProps method
                        // to render a checkbox
                        // Header: ({ getToggleAllRowsSelectedProps }: UseRowSelectInstanceProps<Data>) => (
                        //   // <div>
                        //   <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                        //   // </div>
                        // ),
                        // The cell can use the individual row's getToggleRowSelectedProps method
                        // to the render a checkbox
                        Cell: ({ row }) => {
                            const { type = 'checkbox', onChange: onSelectChange } = rowSelection;
                            const onChange = (evt) => {
                                // console.log('cell change', evt, (evt.target as HTMLInputElement).checked, row);
                                onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange([row.index], evt.target.checked);
                            };
                            return type === 'checkbox' ? (_jsx(IndeterminateCheckbox, Object.assign({}, row.getToggleRowSelectedProps({ onChange })))) : (_jsx(Radio, Object.assign({}, row.getToggleRowSelectedProps({ onChange }))));
                        },
                    },
                    ...columns,
                ]);
            },
        ]
        : []));
    return (_jsxs(_Fragment, { children: [isLoading ? (_jsx(Center, Object.assign({ minH: "20rem", h: "100%", color: "gray.300" }, { children: "Loading..." }))) : (_jsxs(OriginTable, Object.assign({}, extraTableProps, getTableProps(), { children: [_jsx(Thead, { children: headerGroups.map((headerGroup) => (_jsx(Tr, Object.assign({}, headerGroup.getHeaderGroupProps(), { children: headerGroup.headers.map((column) => (_jsx(Th, Object.assign({}, column.getHeaderProps(), { children: column.render('Header') })))) })))) }), _jsx(Tbody, Object.assign({}, getTableBodyProps(), { children: rows.map((row) => {
                            prepareRow(row);
                            return (_jsx(Tr, Object.assign({}, row.getRowProps(), { onClick: onRow === null || onRow === void 0 ? void 0 : onRow(row).onClick }, { children: row.cells.map((cell) => (_jsx(Td, Object.assign({ px: tdLayout === 'loose' ? '1.4rem' : '0.75rem' }, cell.getCellProps(), { children: cell.render('Cell') })))) })));
                        }) }))] }))), pagination && _jsx(Pagination, Object.assign({}, pagination))] }));
};
export default Table;
